module.exports = __webpack_public_path__ + "img/glass.19aa8071.svg";